import { Injectable } from "@angular/core";
import { BaseClient } from "../base-client/base-client";
import { IBaseClient } from "../base-client/interface";

@Injectable({
  providedIn: 'root'
})
export class SbhClient extends BaseClient implements IBaseClient {
  constructor() {
    super();
  }

  override needsAgentList: boolean = true;
  override allowAgentToAddTheirId: boolean = true;
  override requireTermsModal: boolean = true;
  override allowedToUseCapture: boolean = true;

  override getAgent(): string | null {
    // get from dataService if present.
    // const agentFromService = this.dataService.getAgent();
    // if (agentFromService) {
    //   return agentFromService;
    // }

    // get from localStorage if exists
    const agent = localStorage.getItem("agent");
    if (agent) {
      return agent;
    }



    // Implementation for getting agent details
    return null;
  }
}
